
import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const getPaymentMethods = async () => {
  let response;
  try {
    response = await apiWrapper(
      "GET",
      "/authorization-methods?type=limited_express_ticket&include_payment=true");

    console.log(">>> getPaymentMethods", response?.data);

    if (response?.data?.length) {
      store.commit("MFITT/setPaymentMethods", response.data);
      store.commit("MFITT/setSelectedPaymentMethod", response.data[0].id);
    }
  } catch (err) {
    console.log('ERROR"" getPaymentMethods():', err);
    throw err;
  }
  return response?.data;
};
